import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import { GreenerLogo } from 'components/assets/GreenerLogo';
import { ProjectPartnerLogo } from 'pages/Blueprints/components/ProjectPartnersBox/ProjectPartnerLogo';
import { Blueprint } from 'types';
import { DATE_FORMAT, GREENER_ORGANISATION_ID } from 'utils/constants';
import { representDate } from 'utils/formatters';
import { getProjectTypeTranslationKey } from '../utils';

export const PdfHeader = ({ blueprintDetails }: { blueprintDetails: Blueprint }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isWeeklyBreakdown = !blueprintDetails.tsEnd;
  const isGreenerPartner = blueprintDetails?.partnerOrganisation?.organisationId === GREENER_ORGANISATION_ID;
  const isCreatedByGreener = blueprintDetails?.organisation?.organisationId === GREENER_ORGANISATION_ID;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.brand['forest-green'],
        height: '100%',
      }}
      p={6}
      justifyContent="space-between"
      display="flex"
      flexDirection="column"
    >
      <Box display="flex" gap={3}>
        <GreenerLogo fullWidth logoColor={theme.palette.brand['lime-green']} />
        {!isGreenerPartner && !isCreatedByGreener && (
          <ProjectPartnerLogo blueprintDetails={blueprintDetails} height="42px" />
        )}
      </Box>

      <Box>
        <Typography variant="h1" color={theme.palette.brand['lime-green']} textTransform="uppercase" fontWeight={900}>
          {blueprintDetails.name}
        </Typography>

        <Typography color="white" variant="body1" mt={1.5}>
          {blueprintDetails.clientName}
          &nbsp;&nbsp;•&nbsp;&nbsp;{t(getProjectTypeTranslationKey(blueprintDetails.projectTypeId))}
          <br />
          {isWeeklyBreakdown && `${t('blueprints:details.startDate')}: `}
          {representDate(blueprintDetails.tsStart, DATE_FORMAT)}
          {isWeeklyBreakdown ? (
            <>
              <br />
              {t('blueprints:details.weeklyBreakdown')}
            </>
          ) : (
            <>&nbsp;&nbsp;/&nbsp;&nbsp;{representDate(blueprintDetails.tsEnd, DATE_FORMAT)}</>
          )}
        </Typography>
      </Box>
    </Box>
  );
};
